import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import DownloadIcon from '@mui/icons-material/Download';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import QuizIcon from '@mui/icons-material/Quiz';
import SchoolIcon from '@mui/icons-material/School';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import { Button, CircularProgress, Dialog, DialogContent, Drawer } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axios";
import GetData from '../GlobalComponents/getData';
import ActiveEmail from "../pages/sidebar/sidbarOptionsContent/Settings/components/ActiveEmail";
import { Play, X, ChevronLeft, ChevronRight, CheckCircle2 } from 'lucide-react';



    const courses = localStorage.getItem('coursesLength');
    const questionLists = localStorage.getItem('qestionListsLength');
    const students = localStorage.getItem('studentsLength');
    const emailActive = localStorage.getItem("emailActive");
    const LearnersList = localStorage.getItem("LearnersList");
    const SlectedTab = sessionStorage.getItem("tab");
// Extract the app link based on user OS
function getUserOS() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (/android/.test(userAgent)) {
        return "https://play.google.com/store/apps/details?id=com.Gamizign.Students";
    }
    if (/iphone|ipad|ipod/.test(userAgent)) {
        return "https://apple.co/49Pc7I6";
    }
    if (/win/.test(userAgent)) {
        return "https://play.google.com/store/apps/details?id=com.Gamizign.Students";
    }
    if (/mac/.test(userAgent)) {
        return "https://apple.co/49Pc7I6";
    }
    if (/linux/.test(userAgent)) {
        return "https://play.google.com/store/apps/details?id=com.Gamizign.Students";
    }
    return "https://play.google.com/store/apps/details?id=com.Gamizign.Students";
}
    export const toDoList =[
        {tab:SlectedTab, title:'GetStarted.CreateAccount',status:true,detail:'accound had been created',link:``,icon:<AccountCircleIcon className="text-[#4183d9]" />},
        {tab:1, title:'GetStarted.CreateFirstQuestionList',status:questionLists>0,detail:'Create a new question list.',link:`/Dashboard/adding`,icon:<QuizIcon />},
        {tab:1, title:'GetStarted.CreateFirstCourse',status:courses>0,detail:'Create a new course.',link:`/Dashboard/CreateCourse`,icon:<CastForEducationIcon />},
        {tab:6, title:'GetStarted.AddFirstStudent',status:students>0,detail:'add a new student',link:`/Dashboard/learnerList`,icon:<SchoolIcon />},
        {tab:SlectedTab, title:'GetStarted.DownloadApp',status:false,detail:'DownloadApp',link:getUserOS(),icon:<DownloadIcon />},
        {tab:3, title:'GetStarted.PlayFirstActivity',status:false,detail:'Play arcade first activity',link:`/Dashboard/Courses`,icon:<SportsEsportsIcon />},
        {tab:1, title:'GetStarted.CreateFirstAiQuestion',status:questionLists>0,detail:'Create AI question list',link:`/Dashboard/adding`,icon:<AutoFixHighIcon />},
        {tab:SlectedTab, title:'GetStarted.ActivateYourEmail',status:emailActive,detail:'Activate your email',link:`email`,icon:<MarkEmailReadIcon />},
    ];
export default function CheckList({showCheckList, setShowCheckList}){
    const {t, i18n} = useTranslation(); 
    const [checListWidth, setChecListWidth] = useState('sm:w-[420px] w-[320px]');
    const [isLoading, setIsLoading] = useState(true);
    const {data} = GetData();    
    const firstCourse_id = data?.published[0]?.course_id 
    const emailRef = useRef(null);
    useEffect(()=>{
        const getCourse = async() => {
            setIsLoading(true);
            try{
              const analytics = await axiosInstance.get(`${process.env.REACT_APP_ENDPOINT}/analytics/courses/${firstCourse_id}`);
              const done = analytics.data.score>0;
              toDoList[4].status=done;
              toDoList[5].status=done;
            }catch(error){
                console.log(error);
                
            }finally{setIsLoading(false);}
        }
        if (firstCourse_id) {
             getCourse();
        };
    },[firstCourse_id]);
    const [watchDemo, setWatchDemo] = useState(false);
    const [demoIndex, setDemoIndex] = useState(0);
    const demoVideos = [
        {title:t("GetStarted.CreateQuestionsList"), link:"https://www.youtube.com/embed/-ftdANrmAF0?si=WI5R8Ln_ILXX4CVV"},
        {title:t("GetStarted.CreateSingleCourse"), link:"https://www.youtube.com/embed/72GV0s4Ypac"},
        {title:t("GetStarted.CreateJourneyCourse"), link:"https://www.youtube.com/embed/L5cngeLkgKM?si=KCwh4-jLIKVbdKkt"},
    ]
    const navigate = useNavigate();
    const handleGetStart = (status, link, tab, action) => {
        if (!status) {
            // 👉 If it's the DownloadApp action — open link directly
            if (action === "DownloadApp") {
                window.open(link, "_blank"); // behaves like <Link />
                return;
            }
            // 👉 Special case: email click
            if (link === "email") {
                emailRef.current?.click();
                return;
            }
            // 👉 Normal navigation for all other actions
            const state = { courses: "", courseType: "", course: "", questionlist: true };
            navigate(link, { state });
            setShowCheckList(false);
            sessionStorage.setItem("tab", tab);

        } else {
            // console.log("already done");
        }
    };
    // return(
    const isRTL = i18n.language === 'ar';
    const completedCount = toDoList.filter(item => item.status).length;
    const progressPercent = Math.round((completedCount / toDoList.length) * 100);

    return (
        LearnersList === 'show' ? (
            <Drawer
                anchor={isRTL ? 'left' : 'right'}
                open={showCheckList}
                onClose={() => setShowCheckList(false)}
                PaperProps={{
                    style: {
                        boxShadow: '-10px 0px 30px rgba(0,0,0,0.05)',
                        borderLeft: isRTL ? 'none' : '1px solid #f1f5f9',
                        borderRight: isRTL ? '1px solid #f1f5f9' : 'none',
                    }
                }}
            >
                {/* Watch demo dialog */}
                <Dialog
                    open={watchDemo}
                    onClose={() => { setWatchDemo(false); setDemoIndex(0); }}
                    PaperProps={{
                        style: {
                            borderRadius: '24px',
                            padding: '16px',
                            maxWidth: '550px',
                            width: '95%'
                        }
                    }}
                >
                    <DialogContent>
                        <div className="flex flex-col gap-4">
                            <div className="flex justify-between items-center">
                                <h2 className="text-base md:text-xl font-black text-slate-800 tracking-tight">
                                    {demoVideos[demoIndex]?.title}
                                </h2>
                                <button
                                    onClick={() => { setWatchDemo(false); setDemoIndex(0); }}
                                    className="p-1.5 rounded-full hover:bg-slate-100 transition-colors text-slate-400 hover:text-slate-600 focus:outline-none"
                                >
                                    <X className="w-5 h-5" />
                                </button>
                            </div>
                            <div className="aspect-video rounded-2xl overflow-hidden shadow-lg border border-slate-100 bg-black">
                                <iframe
                                    src={demoVideos[demoIndex]?.link}
                                    title={demoVideos[demoIndex]?.title}
                                    className="w-full h-full"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </DialogContent>
                    <div className="flex justify-between items-center px-6 pb-4">
                        <Button
                            disabled={demoIndex === 0}
                            onClick={() => setDemoIndex(demoIndex - 1)}
                            variant="outlined"
                            style={{ borderRadius: '12px', textTransform: 'none', fontWeight: 'bold' }}
                            startIcon={<ChevronLeft className="w-4 h-4" />}
                        >
                            Prev
                        </Button>
                        <span className="text-xs font-bold text-slate-400">
                            {demoIndex + 1} / {demoVideos.length}
                        </span>
                        <Button
                            disabled={demoIndex === demoVideos.length - 1}
                            onClick={() => setDemoIndex(demoIndex + 1)}
                            variant="outlined"
                            style={{ borderRadius: '12px', textTransform: 'none', fontWeight: 'bold' }}
                            endIcon={<ChevronRight className="w-4 h-4" />}
                        >
                            Next
                        </Button>
                    </div>
                </Dialog>

                {/* Main Drawer Body */}
                <div className={`${checListWidth} h-[100vh] overflow-y-auto transition-all duration-300 ease-in-out bg-slate-50 flex flex-col`} dir={isRTL ? 'rtl' : 'ltr'}>
                    
                    {/* Header bar */}
                    <div className="flex justify-between items-center px-6 pt-6 pb-4">
                        <h1 className="text-xl md:text-2xl font-black text-slate-800 tracking-tight">
                            {t('GetStarted.GetStarted')}
                        </h1>
                        <button
                            onClick={() => setShowCheckList(false)}
                            className="p-2 rounded-full hover:bg-slate-105 transition-all text-slate-400 hover:text-slate-650 focus:outline-none"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>

                    {/* Progress indicator */}
                    <div className="px-6 pb-4 border-b border-slate-100">
                        <div className="flex justify-between items-center text-xs font-black text-slate-400 mb-2">
                            <span>{isRTL ? 'إكمال الخطوات' : 'STEPS COMPLETED'}</span>
                            <span>{completedCount} / {toDoList.length} ({progressPercent}%)</span>
                        </div>
                        <div className="w-full h-2.5 bg-slate-200/60 rounded-full overflow-hidden">
                            <div className="h-full bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full transition-all duration-500" style={{ width: `${progressPercent}%` }} />
                        </div>
                    </div>

                    {/* Watch Demo banner */}
                    <div className="p-6 pb-2">
                        <div 
                            onClick={() => setWatchDemo(true)} 
                            className="group cursor-pointer bg-slate-900 hover:bg-black text-white rounded-3xl p-5 shadow-xl relative overflow-hidden transition-all duration-300"
                        >
                            <div className="absolute right-0 top-0 w-24 h-24 bg-blue-500/10 rounded-full blur-xl group-hover:scale-125 transition-transform" />
                            <div className="flex items-center gap-4 relative z-10">
                                <div className="p-3 bg-blue-600 rounded-2xl text-white shadow-md shadow-blue-500/30 group-hover:scale-105 transition-transform">
                                    <Play className="w-5 h-5 fill-current" />
                                </div>
                                <div>
                                    <h3 className="font-black text-sm md:text-base tracking-tight">
                                        {isRTL ? 'شاهد العرض التوضيحي' : 'Watch Demo Video'}
                                    </h3>
                                    <p className="text-xs text-slate-400 font-medium mt-0.5">
                                        {isRTL ? 'دليل خطوة بخطوة للبدء' : 'Step-by-step video tutorials'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CheckList Tasks */}
                    <div className="p-6 space-y-4 flex-grow">
                        {toDoList.map((list, index) => {
                            const isCompleted = list.status;
                            return (
                                <div key={index}>
                                    {isLoading && index === 5 ? (
                                        <div className="flex justify-center py-4">
                                            <CircularProgress size={24} />
                                        </div>
                                    ) : (
                                        <div
                                            onClick={() => handleGetStart(list.status, list.link, list.tab, list.detail)}
                                            className={`flex items-center gap-4 p-4 rounded-2xl border transition-all duration-200 cursor-pointer ${
                                                isCompleted
                                                    ? 'bg-slate-100/50 border-slate-200/40 hover:bg-slate-200/20'
                                                    : 'bg-white border-slate-100 hover:border-blue-200 hover:shadow-md hover:-translate-y-0.5'
                                            }`}
                                        >
                                            <div className="flex-shrink-0">
                                                {isCompleted ? (
                                                    <div className="p-1 rounded-full bg-emerald-500 text-white">
                                                        <CheckCircle2 className="w-4 h-4 fill-current text-white" />
                                                    </div>
                                                ) : (
                                                    <div className="w-5 h-5 rounded-full border-2 border-slate-300 hover:border-blue-500 transition-colors" />
                                                )}
                                            </div>
                                            <div className="flex-grow flex items-center gap-3">
                                                <div className={`p-2 rounded-xl flex-shrink-0 ${isCompleted ? 'bg-slate-200/50 text-slate-400' : 'bg-blue-50 text-blue-600'}`}>
                                                    {list.icon}
                                                </div>
                                                <span className={`text-xs md:text-sm font-bold leading-tight ${isCompleted ? 'text-slate-400 line-through' : 'text-slate-850'}`}>
                                                    {t(list.title)}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                    
                </div>
                <div className="hidden">
                    <ActiveEmail emailRef={emailRef} />
                </div>
            </Drawer>
        ) : <></>
    );
}